import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ADPResourceService, CustomFormControl, ListItem } from 'digital-core';

@Component({
  selector: 'pgh-testpage',
  templateUrl: './testpage.component.html',
  styleUrls: ['./testpage.component.scss']
})
export class TestPageComponent implements OnInit {

  languages: ListItem[] = [];

  public testForm = new FormGroup({
    FirstName: new CustomFormControl(),
    LastName: new CustomFormControl(),
    Languages: new CustomFormControl(),
    Phone: new CustomFormControl()
  });

  data : any;

  constructor(
    private resourceService: ADPResourceService,
  ) {}

  getResource(name: string, namespace = null) {
    namespace = namespace ? namespace : "POC";
    let title = namespace + "_" + name;
    let resourceValue = this.resourceService.getViewResourceObject(title);
    return resourceValue;
  }

  ngOnInit() {
    this.resourceService.getListItemResource("Global_Languages").subscribe((data) => {
      this.languages = data;
    });

    setTimeout(() => {
      this.data =   { year: 2022 };

    }, 2000);
  }

}
